import dynamic from 'next/dynamic';

import { CancelledReservationDetailsProps } from './CancelledReservationDetails.types';

export const CancelledReservationDetails = dynamic<CancelledReservationDetailsProps>(() =>
  import('./CancelledReservationDetails').then(module => module.CancelledReservationDetails)
);
